import { ButtonIcon } from '@eliadmin/core/src/components/ui/button-icon';
import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

// Use the shared search on both breakpoints and retain the shop's header styling.
export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  sections: ['products', 'categories', 'articles', 'tags'],
  field: {
    leadingIcon: null,
    buttonIcon: (
      <ButtonIcon
        alt="Hľadať"
        url="/images/icons/search-white.svg"
        className="max-h-[22px] min-h-[22px] min-w-[22px] max-w-[22px]"
      />
    ),
    buttonTextKey: 'text1',
    inputWrapperClassName:
      'border-e-none ea-rounded-[16px] h-[50px] border pr-1 ea-search-bar__input',
    buttonClassName: 'ea-search-bar__button h-[42px] rounded-[12px] font-medium sm:h-[42px]',
    className: { input: { main: 'border-none px-4' } },
  },
};
